<template>
  <div id="app">
    <router-view name="header" />
    
    <router-view/>
      
    <router-view name="footer" />
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
  }
}
</script>

<style lang="scss">
  html {
    scroll-behavior: smooth!important;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue